import { useContext } from 'react';
import { PermissionContext } from './PermissionProvider';

/**
 * useClaimTabSettings — reactive reader for `claim_tab_settings` persisted from
 * GET /me (SA-1760).
 *
 * Reads the array projected by PermissionProvider (kept in sync on login and
 * token refresh via `applyPermissionsFromMe`). Returns the array ordered per BE,
 * or null when unauthenticated / unprovisioned.
 *
 * @returns {Array<object>|null}
 */
export const useClaimTabSettings = () => {
  const { claimTabSettings } = useContext(PermissionContext);
  return claimTabSettings ?? null;
};
